type Chain = 'ropsten'
export const chain: Chain = 'ropsten'
